export default "__VITE_ASSET__C5EJqUTR__"